 

const mutations = {
  SET_HISTORICAL_PRICES_MONTH(state, payload) {
    state.historicalPrices = Object.assign({}, state.historicalPrices, { monthChart: payload.chart });
  },
  SET_HISTORICAL_PRICES_YEAR(state, payload) {
    state.historicalPrices = Object.assign({}, state.historicalPrices, { yearChart: payload.chart });
  }
};

const getters = {
  historicalPrices: state => state.historicalPrices
};

const state = {
  historicalPrices: null
};

export default {
  state,
  getters,
  mutations
};
